import { useEffect } from 'react';

/**
 * Dismisses a dialog on Escape. Registered in the capture phase so the handler
 * fires even while focus sits inside a form field within the dialog.
 */
export function useEscapeKey(onEscape: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      onEscape();
    };

    document.addEventListener('keydown', handleKeyDown, true);
    return () => document.removeEventListener('keydown', handleKeyDown, true);
  }, [onEscape, enabled]);
}
